import React, { FC } from 'react'
import { AuthenticatedUser } from '../../types'

type Props = {
  user?: AuthenticatedUser
  className?: string
}

const Avatar: FC<Props> = ({ user, className }) => {
  if (!user) {
    return null
  }

  return (
    <div
      className={`default-profile-pic rounded-circle d-flex align-items-center justify-content-center bg-primary position-relative overflow-hidden ${className}`}
    >
      {user?.profile_img_url ? (
        <img src={user.profile_img_url} className="rounded-circle nav-profile-pic" alt="profile avatar" />
      ) : (
        <span className="text-white h6 mb-0">{user.first_name?.charAt(0) || ''}</span>
      )}
    </div>
  )
}

export default Avatar
